"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const InterimScreenSubtitle_1 = require("../../atoms/InterimScreenSubtitle/InterimScreenSubtitle");
const InterimScreenTitle_1 = require("../../atoms/InterimScreenTitle/InterimScreenTitle");
function InterimScreenTemplate({ children, environment, title, subtitle, canBeClosed = false, }) {
    const fontFamily = environment === 'neoId' ? 'elsevier' : 'main';
    const isCaLogo = environment !== 'neoId';
    const logo = isCaLogo ? ui_1.Icons.Ca_Logo : ui_1.Icons.Elsevier_Logo;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onClose = (0, react_1.useCallback)(() => {
        navigate(-1);
    }, [navigate]);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { "data-e2e": 'InterimScreenTemplate_Wrapper', children: [canBeClosed && (0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: onClose, "data-e2e": 'InterimScreenTemplate_StyledCloseButton' }), (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'InterimScreenTemplate_Container', children: [(0, jsx_runtime_1.jsx)(StyledIcon, { name: logo, "$isCaLogo": isCaLogo, "data-e2e": 'InterimScreenTemplate_StyledIcon' }), (0, jsx_runtime_1.jsx)(StyledTitle, { fontFamily: fontFamily, "data-e2e": 'InterimScreenTemplate_StyledTitle', children: title }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { fontFamily: fontFamily, "data-e2e": 'InterimScreenTemplate_StyledSubtitle', children: subtitle }), children] })] }));
}
exports.InterimScreenTemplate = InterimScreenTemplate;
const Wrapper = styled_components_1.default.div `
  /* Fix to show the page over other UI */
  position: absolute;
  z-index: 2;

  height: 100vh;
  width: 100vw;
  box-sizing: border-box;

  padding: 40px;
  background: ${props => props.theme.background};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Container = styled_components_1.default.div `
  max-width: 546px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin-bottom: 36px;

  ${ui_1.device.mobileL `
    margin-bottom: 4px;
  `}

  ${ui_1.device.laptopS `
    margin-bottom: 34px;
  `}
  
  ${({ $isCaLogo }) => $isCaLogo &&
    (0, styled_components_1.css) `
      height: 122px;
    `}
`;
const StyledTitle = (0, styled_components_1.default)(InterimScreenTitle_1.InterimScreenTitle) `
  margin-bottom: 33px;

  ${ui_1.device.laptopS `
    margin-bottom: 22px;
  `}
`;
const StyledSubtitle = (0, styled_components_1.default)(InterimScreenSubtitle_1.InterimScreenSubtitle) `
  margin-bottom: 70px;

  ${ui_1.device.mobileL `
    margin-bottom: 24px;
  `}

  ${ui_1.device.laptopS `
    margin-bottom: 86px;
  `}
`;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  position: absolute;
  top: 45px;
  right: 40px;

  height: 20px;
  width: 20px;

  & > svg {
    height: 20px;
    width: 20px;
  }

  ${ui_1.device.laptopS `
    top: 12px;
    right: 12px;
    
    height: 16px;
    width: 16px;

    & > svg {
      height: 16px;
      width: 16px;
    }
  `}
`;
